// @ts-nocheck — preact-router types don't support path on child components
import Router from "preact-router";
import { HomePage } from "../features/home/HomePage";
import { LoginPage } from "../features/auth/LoginPage";
import { ExplorePage } from "../features/explore/ExplorePage";
import { PricingPage } from "../features/pricing/PricingPage";
import { DocsPage } from "../features/docs/DocsPage";
import { NotFound } from "./NotFound";
import { Footer } from "../components/layout/Footer";

export function App() {
  return (
    <>
      <Router>
        <HomePage path="/" />
        <ExplorePage path="/explore" />
        <PricingPage path="/pricing" />
        <DocsPage path="/docs" />
        <LoginPage path="/login" />
        <NotFound default />
      </Router>
      <Footer />
    </>
  );
}
